import { RetrieveDocumentsReferenceOutputDto } from '@api/ecommerce-xp';
import { useDidMount, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetchDocument } from '@hooks';
import { useServiceResponse } from '@store';

interface TermsAndConditionsResources {
	title: string;
}

interface TermsAndConditionsHelperOutput {
	resources: TermsAndConditionsResources;
	retrieveBankDocumentReference: RetrieveDocumentsReferenceOutputDto | undefined;
}

export const useTermsAndConditionsHelper = (): TermsAndConditionsHelperOutput => {
	const t = useTranslation();

	const { fetchBankDocument } = useFetchDocument();

	useDidMount(() => {
		fetchBankDocument();
	});

	const resources: TermsAndConditionsResources = {
		title: t('placeholders.titleDocumentTermsCondition.title'),
	};

	const { retrieveBankDocumentReference } = useServiceResponse();

	return { resources, retrieveBankDocumentReference };
};
